/**
 * Every minigame under Spelletjes. To add a game, add its key and copy here, a row in the
 * `games` table (with its `game_availability` rows) in a migration, and the game's own folder
 * under `apps/web/src/child/games/`.
 */
export const GAME_KEYS = ['rekenrace'] as const;

export type GameKey = (typeof GAME_KEYS)[number];

export interface GameInfo {
  /** Shown on the Spelletjes cards and as the column header on the Beschikbaarheid page. */
  readonly name: string;
  /** One child-friendly sentence for the Spelletjes card. */
  readonly description: string;
}

export const GAMES: Record<GameKey, GameInfo> = {
  rekenrace: {
    name: 'Rekenrace',
    description: 'Fiets door de poort met de som die jouw getal het grootst maakt.',
  },
};

export function isGameKey(value: unknown): value is GameKey {
  return typeof value === 'string' && (GAME_KEYS as readonly string[]).includes(value);
}
